import React from "react";
import { AnimationInstance } from ".";

const Outliner = ({ color }: { color?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 52.758 60"
    >
      <g data-name="Group 20116" transform="translate(-233.621 -693.156)">
        <g data-name="Group 20115">
          <g data-name="Group 20114">
            <path
              data-name="Path 23049"
              d="m248.5 0 5.056 52.162A26.455 26.455 0 0 0 275.3 26.316 26.562 26.562 0 0 0 248.5 0z"
              transform="translate(11.076 693.156)"
              style={{
                fill: color || "var(--bc-color-primary)",
              }}
            />
            <path
              data-name="Path 23050"
              d="M79.077 26.378C79.077 11.81 68.9 0 56.347 0a26.383 26.383 0 0 0-4.97 52.286L54.729 59a1.808 1.808 0 0 0 3.236 0l3.353-6.713c10.114-2.329 17.759-13.042 17.759-25.909z"
              transform="translate(203.621 693.156)"
              style={{
                fill: color || "var(--bc-color-primary)",
              }}
            />
          </g>
        </g>
        <circle
          data-name="Ellipse 1312"
          cx="23.918"
          cy="23.918"
          r="23.918"
          transform="translate(236.082 695.656)"
          style={{
            fill: "#fff",
          }}
        />
      </g>
    </svg>
  );
};

const BagBubble = ({ id, imageUrl, color }: AnimationInstance) => {
  return (
    <div className="bc-animate-addToBag bc-box-border bc-absolute bc-flex bc-w-[53px] desktop:bc-w-[63.6px] bc-h-[60px] desktop:bc-h-[72px] bc-overflow-hidden bc-origin-bottom bc-top-[-50px] desktop:bc-top-[-59px]">
      <div className="bc-box-border bc-relative">
        <div className="bc-box-border bc-w-[53px] desktop:bc-w-[63.6px] bc-h-[60px] desktop:bc-h-[72px]">
          <Outliner color={color} />
        </div>
        <div className="bc-box-border bc-absolute bc-origin-top bc-top-[0px] bc-w-[53px] desktop:bc-w-[63.6px] bc-h-[53px] desktop:bc-h-[63.6px] bc-flex bc-items-center bc-justify-center">
          <img
            src={imageUrl}
            alt="bag"
            className="bc-box-border bc-w-[40px] desktop:bc-w-[48px] bc-h-[40px] desktop:bc-h-[48px] bc-overflow-hidden bc-rounded-full"
          />
        </div>
      </div>
    </div>
  );
};

export default BagBubble;
